import { reactive } from 'vue';
import Sidebar from './SideBar.vue';
import SidebarLink from './SidebarLink.vue'; // Добавьте .vue, если это компонент Vue

const SidebarStore = reactive({
    showSidebar: false,
    sidebarLinks: [],
    displaySidebar(value) {
        this.showSidebar = value;
    },
});

const SidebarPlugin = {
    install(app) {
        app.provide('sidebar', SidebarStore);
        app.component('side-bar', Sidebar);
        app.component('sidebar-link', SidebarLink);
    },
};

export default SidebarPlugin;
